<template>
    <div>
        <Clist :regresar="false" :Nombre="NameList" @FiltrarC="Lista" :Filtro="Filtro" :isModal="EsModal" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<label>Vendedor </label>
                    <select @change="Lista()"  v-model="Filtro.IdVendedor" class="form-control ml-2">
						<option value="">- Vendedor -</option>
                        <option v-for="(item,index) in ListaVendedores" :key="index" :value="item.IdUsuario">{{item.Nombre}}</option>
                    </select>
				</div>
				<div class="form-group mr-2">
					<label>Estatus </label>
                    <select @change="Lista()"  v-model="Filtro.Estatus" class="form-control ml-2">
						<option value="">- Estatus -</option>
						<option value="Activa">Activa</option>
						<option value="Ganada">Ganada</option>
						<option value="Perdida">Perdida</option>
						<option value="Reemplazada">Reemplazada</option>
						<option value="Vencida">Vencida</option>
                        <!-- <option v-for="(item,index) in ListaVendedores" :key="index" :value="item.IdUsuario">{{item.Nombre}}</option> -->
                    </select>
				</div>
			</template>
			<template slot="header">
                <tr >
                <th>Cotización</th>
				<th></th>
				<!-- <th>Propuesta</th> -->
                <th>Cliente</th>
                <th>Propiedad</th>
                <th class="text-center">Gross Profit</th>
                <th class="text-center">Utilidad Aprox.</th>
                <!-- <th>Misceláneos</th> -->
                <!-- <th>Costo KM</th> -->
                <th class="text-center">Costo Total</th>
                <th class="text-center">Valor de Venta</th>
                <th class="text-center">Fecha</th>
				<th class="text-center">Estatus</th>
                <th>Acciones</th>
                </tr>
            </template>
			<template slot="body">
				<tr v-for="(lista,index) in Listacotizacion_servicio" :key="index" :class="lista.Estatus=='Vencida' ? 'bg-danger':''">
					<td>{{lista.Folio }}</td>
					<td><button v-show="lista.Critica==1" type="button" class="btn-icon-02" v-b-tooltip.hover.lefttop  title="Propuesta Crítica"><i class="fa fa-exclamation"></i></button></td>
					<!-- <td>{{lista.Numero==null ? '-' : lista.Numero }}</td> -->
                    <td>{{lista.Cliente.substr(0, 20) }}</td>
                    <td>{{lista.Sucursal.substr(0, 20) }}</td>
                    <td class="text-center">{{ lista.GrossProfit }}%</td>
                    <td class="text-center">{{ lista.Utilidad }}%</td>
                    <!-- <td>${{Number(lista.totalMateriales).toLocaleString() }}</td> -->
                    <!-- <td>${{Number(lista.totalManoDeObra).toLocaleString()}}</td> -->
                    <!-- <td>${{Number(lista.totalMiscelaneos).toLocaleString()}}</td> -->
                    <!-- <td>${{Number(lista.costoKm ).toLocaleString()}}</td> -->
                    <td class="text-center">${{Number(lista.TotalGlobal).toLocaleString('es-MX') }}</td>
                    <td class="text-center">${{ Number(lista.ValorVenta).toLocaleString('es-MX') }}</td>
                    <td class="text-center"><i class="fas fa-calendar-day"></i>  {{lista.FechaCotiServicio }}</td>
					<td class="text-center">{{lista.Estatus==null ? '-' :  lista.Estatus}}</td>
                    <td>
                        <Cbtnaccion :isModal="EsModal" :pShowButtonEdit="lista.Estatus!='Ganada'" :Id="lista.IdCotizacionServicio" :IrA="FormName" >
                        <template slot="btnaccion">
                            <button v-b-tooltip.hover.lefttop  title="Cotización Interna" @click="Descargar(lista.IdCotizacionServicio)"  type="button" class="btn-icon mr-2">   <i :id="'cotizacion'+lista.IdCotizacionServicio" class="fas fa-file-pdf"></i> </button>
							<button v-show="lista.Propuesta=='1'" v-b-tooltip.hover.lefttop  title="Propuesta" @click="DescargarCliente(lista.IdCotizacionServicio,lista.FechaReg)"  type="button" class="btn-icon mr-2">   <i :id="'propuesta'+lista.IdCotizacionServicio" class="fas fa-file-pdf"></i> </button>
							<!-- <button v-b-tooltip.hover.lefttop  title="Orden Compra" @click="DescargarDistribuidor(lista.IdCotizacionServicio)"  type="button" class="btn-icon btn-pink mr-2">   <i class="fas fa-file-pdf"></i> </button> -->
							<button v-show="lista.Propuesta=='0'" v-b-tooltip.hover.lefttop  title="Copiar Cotización" @click="Copiar(lista.IdCotizacionServicio)"  type="button" class="btn-icon mr-2">   <i class="fas fa-copy"></i> </button>

                            <!-- <button v-b-tooltip.hover.lefttop  title="Cotización Interna" @click="Descargar(lista.IdCotizacionServicio)"  type="button" class="btn-icon mr-2">   <i class="fas fa-file-pdf"></i> </button> -->
							<!-- <button v-b-tooltip.hover.lefttop  title="Orden Compra" @click="DescargarDistribuidor(lista.IdCotizacionServicio)"  type="button" class="btn-icon btn-pink mr-2">   <i class="fas fa-file-pdf"></i> </button> -->
                        </template>
                        </Cbtnaccion>
                    </td>
                </tr>
				<CSinRegistros :pContIF="Listacotizacion_servicio.length" :pColspan="12" ></CSinRegistros>
            </template>
        </Clist>
    </div>
</template>
<script>

import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import CSinRegistros from "../../../components/CSinRegistros";

export default {
    name :'listCotizaciones',
    components :{
        Clist,
		Cbtnaccion,
		CSinRegistros
    },
    data() {
        return {
            FormName:'cotizacion_principal',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:false,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-xl",
            NameList:"Lista de Cotizaciones de Servicios",
            NameForm:"Lista de Cotizaciones de Servicios",
            urlApi:"cotizacion_servicio/get",
            Listacotizacion_servicio:[],
            ListaHeader:[],
            Rutaicono:'',
            Filtro:{
                Nombre:'',
                Placeholder:'Folio, Cliente, Sucursal.',
				TotalItem:0,
                Pagina:1,
                Entrada:20,
				IdVendedor:'',
				Estatus:''
            },
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			ListaVendedores:[]
        }
    },
    methods: {
		async Lista() {
			this.ConfigLoad.ShowLoader = true;

			await this.$http.get(
				this.urlApi,
				{
					params:{
						Nombre:this.Filtro.Nombre,
						Entrada:this.Filtro.Entrada,
						pag:this.Filtro.Pagina, 
						RegEstatus:'A',
						IdVendedor:this.Filtro.IdVendedor,
						Estatus:this.Filtro.Estatus
					}
				}
			).then( (res) => {
				this.Listacotizacion_servicio =res.data.data.row;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
				this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});

		},

        Eliminar(Id)
        {
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    this.$http.delete(
                        'cotizacion_servicio/' + Id
                    ).then( (res) => {
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    });
                }
            });
        },
		Copiar(Id){
			this.$swal({
                title: 'Esta seguro que desea copiar esta cotización?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
					let formData=new FormData();
					formData.set('IdCotizacionServicio',Id);
					this.ConfigLoad.ShowLoader=true;
                    this.$http.post(
                        'cotizacion_servicio/copy',formData
                    ).then( (res) => {
                        this.$toast.success('Cotización copiada con éxito');
                        this.Lista();
                    });
                }
            });
		},
		GetVendedores(){
			this.$http.get('vendedorcotizacion/get').then((res)=>{
				this.ListaVendedores=res.data.data.vendedor;
			})
		},
        Change(titulo)
        {
            this.NameForm=titulo;
            var bdn=true;
            if(titulo=='Iconos'){
                bdn=false;
            }
            this.bus.$emit('cambiar_CloseModal',bdn);
        },
        Limpiar(){
            this.bus.$emit('cambiar_CloseModal',true);
        },
        get_form(){
            this.$router.push({name:'cotizacion_principal', params: { tipolistp:this.TipoList,Id:0}});
        },
        Descargar(IdCotizacion)
        {
			let ActivarSpinner = document.getElementById(`cotizacion${IdCotizacion}`);
            ActivarSpinner.setAttribute('class','fa fa-spinner fa-pulse fa-1x fa-fw');
            this.$http.get('reporte/Cotizacion',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
				ActivarSpinner.setAttribute('class','fas fa-file-pdf');
                /*
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Servicio.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();*/
            });
        },
		DescargarCliente(IdCotizacion,FechaCotiServicio){
			let ActivarSpinner = document.getElementById(`propuesta${IdCotizacion}`);
            ActivarSpinner.setAttribute('class','fa fa-spinner fa-pulse fa-1x fa-fw');
			let FechaCotizacion=new Date(FechaCotiServicio).getTime();
			// console.log(FechaCotiServicio);
			let FechaComparar=new Date('2025-11-18').getTime();
			// console.log(FechaComparar);
			let Ruta='';
			if (FechaCotizacion<FechaComparar) {
				Ruta='reporte/cotizacioncliente';
			}
			else{
				Ruta='reporte/cotizacionclientepro';
			}
			this.$http.get(Ruta,
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
				ActivarSpinner.setAttribute('class','fas fa-file-pdf');
            });
		},

		DescargarDistribuidor(IdCotizacion){
			this.$http.get('reporte/cotizaciondistribuidor',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
		}
    },
    created()
    {
        this.bus.$off('Delete');
        this.bus.$off('List');
        this.bus.$off('Limpiar');
        this.bus.$off('Regresar');
        this.bus.$off('Nuevo');
		this.GetVendedores();
        this.Lista();

        this.bus.$on('Nuevo',()=>
        {
            this.get_form();
        });

        this.bus.$on('Delete',(Id)=>
        {
            this.Eliminar(Id);

        });
        this.bus.$on('List',()=>
        {
            this.Lista();
        });

        this.bus.$on('Limpiar',()=>
        {
            this.Limpiar();
        });
        this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'submenucotizacion'});
        });
    }
}
</script>
